import { useUiTranslator } from "../hooks/useUiTranslator";
import { useAtomValue } from "jotai";

import { JSX } from "react";

import { Box, CircularProgress, Modal, Typography } from "@mui/material";

import { maintenanceModeAtom } from "./maintenanceMode";

export function MaintenanceModeOverlay(): JSX.Element {
  const isActive = useAtomValue(maintenanceModeAtom);
  const t = useUiTranslator();

  return (
    <Modal open={isActive} disableEscapeKeyDown sx={{ zIndex: 9999 }}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 2,
          p: 4,
          bgcolor: "background.paper",
        }}
      >
        <Typography variant="h4">
          {t("CustomApp:maintenance.title", "We'll be right back")}
        </Typography>
        <Typography variant="body1" sx={{ maxWidth: "30em" }}>
          {t(
            "CustomApp:maintenance.body",
            "The application is temporarily unavailable. Please try again in a few minutes.",
          )}
        </Typography>
        <CircularProgress sx={{ mt: 2 }} />
      </Box>
    </Modal>
  );
}
